class CheckboxFormElementController {
  constructor() {
    this.name = 'checkboxFormElement';
  }
}

export default CheckboxFormElementController;
